import { getTeamUrl } from 'Common'

export default [
  { name: 'Caveats', path: getTeamUrl('settings/caveats') },
  { name: 'Item Descriptions', path: getTeamUrl('settings/item_descriptions') }
];